import { Route } from 'react-router-dom';
import Auth from '../layouts/Auth';
import Login from '../pages/Login';

/**
 * Rutas de autenticación - compartidas por admin, shop, fleet
 * Retorna un array de Route elements para usar con spread en Routes
 */
export const authRoutes = (
  <Route path="auth" element={<Auth />}>
    <Route index element={<Login />} />
    <Route path="login" element={<Login />} />
    <Route path="*" element={<Login />} />
  </Route>
);
